import PublicLayout from "@/components/PublicLayout";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <PublicLayout>
      <section className="celestial-bg min-h-[60vh] grid place-items-center">
        <div className="text-center px-5">
          <p className="scripture-quote text-2xl text-brand-quiet">“Be still, and know that I am God.”</p>
          <p className="text-xs text-brand-muted mt-1">— Psalm 46:10</p>
          <h1 className="mt-10 font-serif text-6xl text-brand-ink">404</h1>
          <p className="text-brand-quiet mt-2">The page you sought has wandered.</p>
          <Link
            to="/"
            data-testid="notfound-home-link"
            className="mt-8 inline-flex rounded-full bg-brand-sky text-white hover:bg-brand-skyDark transition-colors px-6 py-3 font-medium"
          >
            Return home
          </Link>
        </div>
      </section>
    </PublicLayout>
  );
}
